// components/NotFound.js
import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

const style = { marginBottom: '4px', textAlign: 'center' };
const NotFound = () => {
  const { t } = useTranslation();
  return (
    <Box
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        height: '100%',
      }}
    >
      <h3>404 page not found</h3>
      <p style={style}>
        {t('errors.pageNotFoundBody', 'We are sorry but the page you are looking for does not exist.')}
      </p>
      <p style={style}>
        You can click <a href="/">Here</a> to go back to your home screen.
      </p>
    </Box>
  );
};

export default NotFound;
